// Module
var code = `<div class="page-content quick-start">
  <h3>Spyne Code Playground</h3>
  <p>{{text}}</p>

  <div id="code-container"></div>
</div>
`;
// Exports
module.exports = code;